@import "../../global/temporary-mercury-overrides/_button.scss";

$versionsListPadding: 14px;

:host {
  --spacing-body-block-start: 24px;
  --spacing-body-block-end: 24px;
  --spacing-body-inline-start: 16px;
  --spacing-body-inline-end: 16px;

  display: grid;
  inline-size: 100%;
  block-size: 100%;
  gap: var(--spacing-gap-xl);
  overflow: auto;
  grid-template-rows: max-content 1fr max-content;
  background-color: var(
    --elevation-background-color,
    var(--color-accent-surface-elevation-2)
  );
  color: var(--color-text-neutral-default);
  text-align: center;
}
.section {
  // section was addad for semantics, in order to allow a footer tag.
  display: contents;
}

.header {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-gap-m);
}

.main {
  overflow: auto;
  display: grid;
  grid-template-rows: 1fr max-content;
  gap: var(--spacing-gap-xxl);
}

.logo {
  &__container {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-gap-l);
    align-items: center;
    margin: unset;
  }
  &__img {
    $logoSize: 28px;
    inline-size: $logoSize;
    block-size: $logoSize;
  }
}
.logotype {
  color: var(--color-text-neutral-default);
}

.versions__container {
  overflow: hidden;
  border: 1px solid var(--color-border-surface-on-elevation-1);
  border-radius: 4px;
  display: grid;
  grid-template-rows: 1fr max-content;
  inline-size: 100%;

  button {
    justify-self: center;
    min-inline-size: 72px;
  }
}
.versions__container-footer {
  padding: $versionsListPadding;
}

.versions__list {
  overflow: auto;
  list-style: none;
  margin: 0;
  padding: $versionsListPadding;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-gap-m);
}

.link-underlined {
  // TODO: Add link helper class in Mercury
  text-decoration: underline;
  color: var(--color-text-neutral-default);
  &:hover {
    color: var(--color-text-neutral-hover);
  }
  &:active {
    color: var(--color-text-neutral-pressed);
  }
}

.links-container {
  display: flex;
  gap: var(--spacing-gap-m);
}

.footer {
  // TODO: Add color helper classes in Mercury
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: var(--spacing-gap-m);
  color: var(--color-text-neutral-disabled);
}
